import { render } from "./TomorrowOrders.vue?vue&type=template&id=972927c0&scoped=true"
import script from "./TomorrowOrders.vue?vue&type=script&lang=js"
export * from "./TomorrowOrders.vue?vue&type=script&lang=js"

import "./TomorrowOrders.vue?vue&type=style&index=0&id=972927c0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972927c0"]])

export default __exports__